import { render } from "./half.vue?vue&type=template&id=11798e18&scoped=true&ts=true"
import script from "./half.vue?vue&type=script&setup=true&lang=ts"
export * from "./half.vue?vue&type=script&setup=true&lang=ts"

import "./style/single-page.less?vue&type=style&index=0&id=11798e18&scoped=true&lang=less"
import "./style/pagination.less?vue&type=style&index=1&id=11798e18&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11798e18"],['__file',"src/views/browse-view/half.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11798e18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11798e18', __exports__)) {
    console.log('reload')
    api.reload('11798e18', __exports__)
  }
  
  module.hot.accept("./half.vue?vue&type=template&id=11798e18&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('11798e18', render)
  })

}


export default __exports__